import React from 'react'
import PersonOutlineIcon from 'components/material-symbol/icons/PersonOutline'
import LocationOnIcon from 'components/material-symbol/icons/LocationOn'
import EventNoteIcon from 'components/material-symbol/icons/EventNote'
import ShowChartIcon from 'components/material-symbol/icons/ShowChart'
import golferHeaderImage from 'images/welcome-golfer-header.png'
import WelcomeRoleCard from '../welcome-role-card'

export default function Golfer() {
  return (
    <WelcomeRoleCard
      testid="golfer-tile"
      to="/club"
      audience="For players"
      roleTitle="Golfer"
      intro="For anyone taking lessons or looking for a coach."
      headerIcon={<PersonOutlineIcon />}
      headerImage={golferHeaderImage}
      headerImageAlt="Golfer swinging on a course"
      headerImagePosition="center 30%"
      continueLabel="Continue as Golfer"
      features={[
        {
          key: 'find-coach',
          icon: <LocationOnIcon />,
          text: 'Find the right PGA Coach',
        },
        {
          key: 'book-lessons',
          icon: <EventNoteIcon />,
          text: 'Book lessons in seconds',
        },
        {
          key: 'track-journey',
          icon: <ShowChartIcon />,
          text: 'Track your golf journey',
        },
      ]}
    />
  )
}
